import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_ARTICLES = "articles";
const BASE_URL = "/api/articles";

const ArticleQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const ARTICLE_EMPTY =
    {
        title: "",
        description: "",
        timeCreated: "",
        filesarticles: []
    };

export function useArticles() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ARTICLES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...ArticleQueryConfig
    });
    return {...result, articles: result.data};
}


export function useArticle(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ARTICLES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...ArticleQueryConfig
    });
    return {...result, article: result.data};
}

export function useArticleMutations() {
    async function createFunction(artice) {
        if (!artice) return;
        return await fetchPOST(BASE_URL, artice, false);
    }

    async function editFunction(article) {
        if (!article) return;
        return await fetchPUT(`${BASE_URL}/${article.id}`, article);
    }

    async function editAddNewFiles(article) {
        if (!article) return;
        return await fetchPUT(`${BASE_URL}/${article.id}/files`, article.filesIds);
    }

    async function deleteFunction(article) {
        return await fetchDELETE(`${BASE_URL}/${article.id}`)
    }

    return {
        createArticle: useMyMutation(createFunction, REACT_QUERY_ID_ARTICLES, article => `Article ${article.title} created`),
        editArticle: useMyMutation(editFunction, REACT_QUERY_ID_ARTICLES, article => `Article ${article.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_ARTICLES, article => `Article ${article.title} modified`),
        deleteArticle: useMyMutation(deleteFunction, REACT_QUERY_ID_ARTICLES, article => `Article ${article.title} deleted.`)
    };

}